import React from "react";
import { FaTable } from "react-icons/fa";
import TableProductList from "./TableProductList";
import { useAppContext } from "../../context/appContext";

const Sidebar = () => {
    const { basket, clearBasket, selectTable, saveTable, togglePayment } = useAppContext();

    const selectTableHandler = (event) => {
        selectTable(null, "new");
    };

    const totalPaymentHandler = () => {
        if (basket.TotalPrice > 0) {
            togglePayment();
        }
    };

    return (
        <div className='flex-2 just flex min-w-[27.5rem] flex-col bg-main-50'>
            <div
                onClick={selectTableHandler}
                className='flex max-h-[5rem] flex-1 cursor-pointer flex-col items-center justify-center bg-gray-400 py-3'
            >
                <FaTable className='text-3xl' />
                <p className='text-md  mt-2 uppercase tracking-widest'>Table plan</p>
            </div>
            <div className='flex  text-gray-900'>
                <h2 className='mx-auto my-2 text-4xl uppercase tracking-wider text-gray-800'>
                    Table {basket.tableNum ? basket.tableNum : ""}
                </h2>
            </div>
            <div className='flex h-full flex-col justify-between'>
                <TableProductList />
                <div className='flex w-full  flex-col items-center justify-around  '>
                    <div className='w-full pr-6 text-right text-2xl font-normal text-black  '>
                        <span className='text-xl'>Total:</span> {basket.TotalPrice.toFixed(2)} £
                    </div>
                    <div className='flex w-full flex-1 items-center justify-around py-4 px-4 font-light uppercase'>
                        <a
                            onClick={clearBasket}
                            href='#'
                            className='rounded bg-red-500 py-5 px-5 text-lg'
                        >
                            Delete
                        </a>
                        <a
                            href='#'
                            className='rounded bg-main-500 py-5 px-5 text-lg'
                            onClick={saveTable}
                        >
                            Save items
                        </a>
                        <a
                            href='#'
                            onClick={totalPaymentHandler}
                            className='rounded bg-green-500 py-5  px-10 text-lg'
                        >
                            Pay
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
